export const env = {
  csp: {
    hash: process.env.NEXT_PUBLIC_CSP_SHA256_HASH,
    scriptSrcDomains: process.env.NEXT_PUBLIC_CSP_SCRIPT_SRC_DOMAINS,
    styleSrcDomains: process.env.NEXT_PUBLIC_CSP_STYLE_SRC_DOMAINS,
    connectSrcDomains: process.env.NEXT_PUBLIC_CSP_CONNECT_SRC_DOMAINS,
    fontSrcDomains: process.env.NEXT_PUBLIC_CSP_FONT_SRC_DOMAINS,
    frameSrcDomains: process.env.NEXT_PUBLIC_CSP_FRAME_SRC_DOMAINS,
    imgSrcDomains: process.env.NEXT_PUBLIC_CSP_IMG_SRC_DOMAINS,
    workerSrcDomains: process.env.NEXT_PUBLIC_CSP_WORKER_SRC_DOMAINS,
  },
  sentry: {
    dsn: process.env.SENTRY_DSN,
    enabled: process.env.SENTRY_ENABLED?.toLowerCase() === 'true',
    environment: process.env.SENTRY_ENVIRONMENT,
    org: process.env.SENTRY_ORG,
    authToken: process.env.SENTRY_AUTH_TOKEN,
    project: process.env.SENTRY_PROJECT,
    sessionSampleRate:
      Number(process.env.SENTRY_REPLAYS_SESSION_SAMPLE_RATE) || 0,
    onErrorSampleRate:
      Number(process.env.SENTRY_REPLAYS_ON_ERROR_SAMPLE_RATE) || 0,
    maskAllText:
      process.env.SENTRY_REPLAY_MASK_ALL_TEXT?.toLowerCase() === 'true',
    blockAllMedia:
      process.env.SENTRY_REPLAY_BLOCK_ALL_MEDIA?.toLowerCase() === 'true',
    tracesSampleRateClient:
      Number(process.env.SENTRY_TRACE_SAMPLE_RATE_CLIENT) || 0.2,
    profilesSampleRateClient:
      Number(process.env.SENTRY_PROFILES_SAMPLE_RATE_CLIENT) || 1.0,
    debugClient: Boolean(process.env.SENTRY_DEBUG_CLIENT) || false,
    tracesSampleRateServer:
      Number(process.env.SENTRY_TRACE_SAMPLE_RATE_SERVER) || 0.2,
    profilesSampleRateServer:
      Number(process.env.SENTRY_PROFILES_SAMPLE_RATE_SERVER) || 1.0,
    debugServer: Boolean(process.env.SENTRY_DEBUG_SERVER) || false,
    tracesSampleRateEgde:
      Number(process.env.SENTRY_TRACE_SAMPLE_RATE_EDGE) || 0.2,
    debugEdge: Boolean(process.env.SENTRY_DEBUG_EDGE) || false,
  },
  datadog: {
    application_id: process.env.DATADOG_APPLICATION_ID!,
    client_token: process.env.DATADOG_CLIENT_TOKEN!,
    service: process.env.DATADOG_SERVICE! || 'ecommerce',
    env: process.env.DD_ENV!,
    browserRum: {
      applicationId: process.env.DATADOG_BROWSER_RUM_APPLICATION_ID!,
      clientToken: process.env.DATADOG_BROWSER_RUM_CLIENT_TOKEN!,
      site: process.env.DATADOG_BROWSER_RUM_SITE! || 'datadoghq.com',
      service: process.env.DATADOG_BROWSER_RUM_SERVICE! || 'ecommerce',
      version: process.env.DATADOG_BROWSER_RUM_VERSION! || '5.21.0',
      sessionSampleRate: Number(process.env.DATADOG_SESSION_SAMPLE_RATE),
      sessionReplaySampleRate: Number(
        process.env.DATADOG_SESSION_REPLAY_SAMPLE_RATE
      ),
    },
    browserLogs: {
      clientToken: process.env.DATADOG_BROWSER_LOGS_CLIENT_TOKEN!,
      site: process.env.DATADOG_BROWSER_LOGS_SITE!,
    },
  },
  microsoftClarity: {
    projectId: process.env.NEXT_PUBLIC_MS_CLARITY_PROJECT_ID,
  },
  minimoPercentualDesconto:
    Number(process.env.NEXT_PUBLIC_MINIMO_PERCENTUAL_DESCONTO) || 5,
  minimumDiscountPrice:
    Number(process.env.NEXT_PUBLIC_MINIMO_VALOR_DESCONTO) || 100,
  isDarkTheme: Boolean(process.env.NEXT_PUBLIC_DARKTHEME) || false,
  hereMapsApiKey: process.env.HERE_API_KEY,
  sacApi: process.env.REACT_APP_SAC_API_URI,
  sacToken: process.env.REACT_APP_SAC_TOKEN,
}
